<template>
  <div :class="classes" v-if="show" :style="styleVar">
    <div class="goods-column" v-for="(list, index) of columns" :key="index">
      <div
        class="goods"
        v-for="(item, idx) of list"
        :key="item.id"
        @click="onJumpTo(item)"
      >
        <div class="store" v-if="show.store && item.branch">
          <div class="logo-box">
            <img class="logo" :src="item.branch.logoImageUrl" alt="" />
          </div>
          <div class="name">{{ item.branchName }}</div>
        </div>
        <div :class="['item', item.$class]">
          <div class="image-view">
            <img
              class="modify-price-image"
              v-if="item.promotionUrl"
              :src="item.promotionUrl"
            />
            <c-image
              class="goods-image"
              :src="item.$coverUrl + suffix"
              fit="cover"
              lazy-load
            >
              <div v-if="corner" :class="corner.klass">
                <img class="image" v-if="corner.url" :src="corner.url" />
                <span class="name" v-else>{{ corner.name }}</span>
              </div>
            </c-image>
            <div class="tag" v-if="show.image.tag && item.$tag">
              <div class="name">{{ item.$tag.name }}</div>
              <div class="value">{{ item.$tag.value }}</div>
            </div>
          </div>
          <div class="content">
            <div class="logo-name" v-if="show.content.logoName">
              {{ item.branchLogoName }}
            </div>
            <div class="goods-name" ref="goods-name">
              <div class="label" v-if="show.content.label && label">
                <div
                  class="text"
                  :style="{
                    backgroundColor: label.bgColor,
                    color: label.color
                  }"
                >
                  {{ label.name }}
                </div>
              </div>
              <div class="value">
                {{ item.goodsName }}
              </div>
            </div>
            <div
              class="sub-title"
              v-if="show.content.subTitle && item.itemSubtitle"
            >
              {{ item.itemSubtitle }}
            </div>
            <div class="view1">
              <div class="label-box" v-if="show.content.marketLabel">
                <div class="label" v-if="item.marketTag1">
                  {{ item.marketTag1 }}
                </div>
                <div class="label" v-if="item.marketTag2">
                  {{ item.marketTag2 }}
                </div>
              </div>
              <div
                class="sales"
                v-if="show.content.monthSales && item.thirtySaleCount"
              >
                月销{{ item.thirtySaleCount }}件
              </div>
            </div>
            <div class="tag" v-if="show.content.tag && item.$tag">
              <div class="value">{{ item.$tag.value }}</div>
            </div>
            <div class="view2">
              <div class="price">
                <div class="label" v-if="show.content.label2">
                  {{ item.estimatePriceTag || (label && label.name) }}
                </div>
                <div
                  class="value"
                  v-if="show.content.price"
                  v-price="item.price"
                />
                <div
                  class="estimate-tag"
                  :style="{'color':item.labelTextColor,'background-color':item.labelColor}"
                  v-if="show.content.estimateTag && item.estimatePriceTag"
                >
                  {{ item.estimatePriceTag }}
                </div>
              </div>
              <div class="marking-price">
                <div
                  class="value"
                  v-if="show.content.markingPrice && item.markingPrice"
                >
                  ¥{{ item.markingPrice }}
                </div>
                <div
                  class="discount"
                  v-if="show.content.discount && item.$discount"
                >
                  {{ item.$discount }}
                </div>
              </div>
            </div>
            <div
              class="btn"
              v-if="show.content.btn && button"
              :style="{
                backgroundColor: button.bgColor,
                color: button.color
              }"
            >
              {{ button.name }}
            </div>
          </div>
          <img
            v-if="shopButton"
            :class="['shop-btn', shopButton.style]"
            :src="item.$stockIsEmpty ? shopButton.emptyImage : shopButton.image"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common';
import { navigateTo } from '@/views/activities/utils';
import { normalizeFloor, setTextIndent } from './utils/index';
import CImage from '@/views/activities/components/c-image';
export default {
  components: { CImage },
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      show: undefined,
      columns: [],
      isWaterfall: false,
      label: undefined,
      button: undefined,
      shopButton: undefined,
      corner: undefined,
      classes: '',
      styleVar: '',
      suffix: '?x-oss-process=style/style_shareatlas_img'
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.unwatch) this.unwatch();
      this.sortGoods();
      normalizeFloor(this);
      setTextIndent(this);
      this.columns = this.normalizeGoods();
      this.unwatch = this.$watch('floor', this.init);
    },
    sortGoods() {
      const { florindex, firstimg } = this.$route.query;
      const { floor } = this;
      const { items } = floor;
      if (florindex && firstimg && floor.id == florindex) {
        const index = items.findIndex(
          (i) => i.indexImage && i.indexImage.imageKey === firstimg
        );
        const item = items[index];
        if (item) {
          items.splice(index, 1);
          items.unshift(item);
        }
      }
    },
    normalizeGoods() {
      const { show } = this;
      const { items } = this.floor;
      const columns = [];
      const column1 = [];
      const column2 = [];

      items.forEach((item, i) => {
        const klass = [];
        const stockIsEmpty = item.goodsStatus === 2;
        const discountTag =
          item.discountTag || item.discountStairDesc || item.discountCouponStr;
        let discount = this.visibleDiscount(item) ? item.discount : '';
        let tag;
        item.$i = i;
        if (item.indexImage) {
          this.$set(item, '$coverUrl', item.indexImage.imageUrl);
        }
        if (item.canReceiveCoupon) {
          tag = {
            name: '优惠',
            value: item.canReceiveCoupon.couponTag
          };
        }
        if (item.estimatePriceTag) {
          discount = '';
          klass.push('has-estimate-tag');
        }
        if (item.markingPrice == item.price) {
          discount = '';
          item.markingPrice = '';
        }
        if (discountTag) {
          tag = {
            name: '优惠',
            value: discountTag
          };
        }
        if (tag) {
          this.$set(item, '$tag', tag);
          show.content.tag && klass.push('has-tag'); 
        }
        if (discount) {
          klass.push('has-discount');
        }
        if (stockIsEmpty) {
          klass.push('empty-stock');
        }
        if (this.isWaterfall) {
          i % 2 === 0 ? column1.push(item) : column2.push(item);
        } else {
          column1.push(item);
        }
        this.$set(item, '$discount', discount);
        this.$set(item, '$class', klass);
        this.$set(item, '$stockIsEmpty', stockIsEmpty);
      });
      column1.length && columns.push(column1);
      column2.length && columns.push(column2);
      return columns;
    },
    onJumpTo(item) {
      let type, value;
      switch (item.goodsLinkType) {
        case 1: // 商品详情页
          type = 3;
          value = item.goodId;
          break;
        case 2: // 二级页面
          type = 11;
          value = item.goodsLinkValue;
          break;
        case 3: // 店铺主页
          type = 4;
          value = item.branchId;
          break;
        case 4: // 品牌首页
          type = 10;
          value = item.branchLogoId;
          break;
        case 5: // 商品详情落地页
          type = 53;
          value = item.goodId;
          break;
        case 6: // 店铺主页落地页
          type = 54;
          value = item.branchId;
          break;
      }
      this.uploadClickGio(item, value, item.$i);
      navigateTo(this, {
        pageLinkType: type,
        pageLinkValue: value,
        goodsId: item.goodId,
        realTenantId:item.realTenantId || item.tenantId || '',
        branchId:item.branchNo
      });
    },
    uploadClickGio(item, value, index) {
      const { home, floor } = this;
      const shared = {
        pageType_var: home.$pageName,
        dataSourceType_var: item.goodsLinkType,
        dataSourcePageID_var: value
      };
      switch (home.$from) {
        case 'home':
          gio('track', 'flowLocationClick', {
            indexId_var: home.contentPageId,
            entryType_vara: floor.modelTitle,
            entryType_floor_var: floor.$index,
            position_var: index,
            sort_var: '',
            ...shared
          });
          break;
        case 'activity':
          gio('track', 'activityFlowLocationClick_var', {
            secondPageID_var: `${home.contentPageId}`,
            entryType_vara: '商品',
            entryType_floor_var: floor.$index,
            position_var: String(index),
            sort_var: '',
            positonName_var: item.goodsName,
            shopID_var: 'n', //切换商场ID  ver607 二级页面流量位点击
            belongShop_var: 'n', //归属商场ID
            // belongShop_var:(item&&item.shopId)||"n",  //归属商场ID
            ...shared
          });
          break;
      }
    },
    visibleDiscount: utils.visibleDiscount()
  }
};
</script>

<style lang="less" scoped>
@import url('./css/base.less');
@import url('./css/row-one.less');
@import url('./css/row-two.less');
@import url('./css/row-three.less');
@import url('./css/row-four.less');
@import url('./css/row-multiple.less');
</style>
